<div class="alert alert-primary" role="alert">
  You've successfully authenticated with the application but you don't currently have any roles assigned. Please contact
  one of the application admins to gain access.
</div>
